import React from 'react';
import gql from 'graphql-tag';
import compose from '../../../../src/web/utils/react/compose';
import widget from '../../../../src/web/components/widgets/decorators/widget';
import BlogCategories from './BlogCategories';
import { NAME, ID } from './properties';
import useQuery from '../../../../modules/react/hooks/useQuery';

const GET_BLOG_CATEGORIES = gql`
  query GetBlogCategories {
    blogCategories {
      id
      ...BlogCategoriesBlogCategories
    }
  }

  ${BlogCategories.fragments.blogCategories}
`;

const defaultCategory = { name: 'RECENT POSTS' };

const BlogCategoriesContainer = () => {
  const { data } = useQuery(GET_BLOG_CATEGORIES);

  if (!data) {
    return null;
  }

  const { blogCategories = [] } = data;
  const categories = [defaultCategory, ...blogCategories];

  return <BlogCategories categories={categories} />;
};

export default compose(
  widget(
    { name: NAME, deprecated: true, componentId: ID },
    { menu: false },
  ),
)(BlogCategoriesContainer);
